import React, { Component } from "react";

export default class AppErrors extends Component {
  componentDidMount() {
    const { onClickClose } = this.props;
    const popup = document.getElementById("popup-bg");

    if (popup) {
      popup.addEventListener("click", () => onClickClose(), false);
    }
  }
  render() {
    const { message, onClickClose, title } = this.props;
    return (
      <div>
        <div className="modal-bg" id="popup-bg" />
        <div className="modal">
          {/* Header */}
          <div className="head-general with-back">
            <a href="javascript: void(0)" />
            <h4 className="info-title">{title || "Whoops!"}</h4>
            <a
              href="javascript: void(0)"
              onClick={onClickClose}
              className="close"
            >
              <icon className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <div className="modal-body">
            <div className="row center-sm">
              <div className="col-sm-12">
                <div className="promo-error white-bg">
                  <p>{message}</p>
                </div>
                <div className="use-buttons">
                  <button className="btn btn-blue" onClick={onClickClose}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
